import React, { useState, useEffect } from 'react';

const TrendModal = ({ trend, onClose, onSubmit }) => {
    const [formData, setFormData] = useState({
        title: '',
        keyword: '',
        keywords_secondary: '',
        length: 'medium',
        faq_questions: ''
    });

    useEffect(() => {
        if (trend) {
            setFormData({
                title: '',
                keyword: trend.query,
                keywords_secondary: trend.trend_breakdown.join(', '),
                length: 'medium',
                faq_questions: ''
            });
        }
    }, [trend]);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({ ...prev, [id]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const lengthMap = {
            'mini': '500-800',
            'short': '800-1200',
            'medium': '1500-2000',
            'long': '2500-3500'
        };
        const payload = {
            article_url: null,
            title: formData.title || null,
            keyword: formData.keyword,
            keywords_secondary: formData.keywords_secondary,
            length: lengthMap[formData.length],
            faq_questions: formData.faq_questions
        };
        onSubmit(payload);
    };

    if (!trend) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={onClose}>
            <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4 text-white">
                    <h2 className="text-xl font-bold">📝 Dodaj trend do kolejki bloga</h2>
                </div>
                <form onSubmit={handleSubmit} className="p-6 space-y-4">
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">Tytuł artykułu</label>
                        <input type="text" id="title" value={formData.title} onChange={handleChange} placeholder="Zostaw puste - AI wygeneruje automatycznie" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
                    </div>
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">Słowo kluczowe główne</label>
                        <input type="text" id="keyword" value={formData.keyword} required readOnly className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 cursor-not-allowed" />
                    </div>
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">Słowa kluczowe drugorzędne</label>
                        <input type="text" id="keywords_secondary" value={formData.keywords_secondary} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
                    </div>
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">Długość artykułu</label>
                        <select id="length" value={formData.length} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                            <option value="mini">Mini (500-800 słów)</option>
                            <option value="short">Krótki (800-1200 słów)</option>
                            <option value="medium">Średni (1500-2000 słów)</option>
                            <option value="long">Długi (2500-3500 słów)</option>
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">Propozycje pytań do FAQ</label>
                        <textarea id="faq_questions" value={formData.faq_questions} onChange={handleChange} rows="4" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Jedno pytanie na linię"></textarea>
                    </div>
                    <div className="flex items-center justify-end gap-3 pt-4 border-t">
                        <button type="button" onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors">Anuluj</button>
                        <button type="submit" className="px-6 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors shadow-sm">📤 Wyślij do Airtable</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default TrendModal;
